import React, { useEffect, useState } from "react";
// import FanGroupNav from './FanGroupNav'
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import "./FanLive.css";
import { serverInfo } from "../../../../../App";
import { useContext } from "react";

const FanGroupLive = () => {
  const { imageCdnUrl } = useContext(serverInfo);
  let { slug } = useParams();

  const [fanDetails, setFanDetails] = useState("");

  useEffect(() => {
    axios.get(`/api/star/fan/group/details/${slug}`).then((res) => {
      if (res.data.status === 200) {
        setFanDetails(res.data.fanDetails);
      }
    });
  }, []);

  return (
    <>
      <div className="ms-4">
        {/* <FanGroupNav/> */}

        <div className="mt-2 mb-3">
          <div className="text-light border border-warning rounded-3 d-flex justify-content-center p-2 mb-3">
            <div className="faTrophy">
              <i className="fa-solid fa-calendar-plus"></i>
            </div>
            <h4 className="mx-3 text-warning p-2">Live Fan Group</h4>
          </div>

          <div className="row my-3">
            <div className="clo-sm-12 col-md-12 col-lg-9 mx-auto">
              <div className=" TextPo">
                <img
                  src={imageCdnUrl+fanDetails.banner}
                  alt=""
                  className="bgBlurDivLive W-100 img-fluid"
                />

                <Link to={`/superstar/fan-group/home/${slug}`}>
                  <button className="btn btn-warning enterBtn fw-bold py-2 px-4 m-5 bottom-rightIMJ ">
                    Enter
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FanGroupLive;
